import { render } from "./ToasterBase.vue?vue&type=template&id=5a3effd2"
import script from "./ToasterBase.vue?vue&type=script&lang=js"
export * from "./ToasterBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__